import { Page, PageContent } from 'src/components/Page'
import Gap from 'lib/components/Gap'
import {
  Button,
  Stack,
  Box,
  Heading,
  Text,
  Accordion,
  AccordionSection,
} from '@kiwicom/orbit-components'
import Image from 'next/image'
import { useState } from 'react'
import SEO from 'src/components/SEO'
import BetterText from 'src/components/BetterText'
import BetterLink from 'src/components/BetterLink'

const faqs = [
  {
    title: 'Proč potřebujete video?',
    // nejefektivnijsi zpusob komunikalce cehokoli co chceme sdelit s cilovkou, oproti vsem ostatnim formam komunikace.
    // 1 minuta videa dokaze rict vic nez xxx radku / slov textu. 80% procent navstevniku koukne na video webu. lide si to vice zapamatuji nez text, diky pribehu odvypravis - jsou v tom emoce (hudba), vtipny = zapamatovatelnejsi. pridat priklad charity water
    text: 'Neexistuje účinnější nástroj pro komunikaci vaší myšlenky vaší cílové skupině, než je video. Říka se, že obraz řekne více než tísíc slov, pak video jich řekne ještě násobně více. Ve videu odvyprávíte příběh. Jako lidské bytosti od nepaměti milujeme příběhy, skrze které se učíme. A právě příběhy společně s obrazem a hudbou tvoří emoce a emoce se velmi silně ukládají do paměti. Pokud hledáte nejefektivnější nástroj komunikace a pokud chcete, aby si divák odnesl nějakou emoci a zapamatoval si vás, pak hledáte video.',
  },
  // video ma mnoho vyuziti - je univerzalni - socky, prezentace na webu, ... s rychlejsim internetem je budoucnost ve videu - tiktok, insta prechazi na video, fb implementuje reels atd.
  {
    title: 'K čemu využít video?',
    text: 'Video je univerzální komunikační nástroj a lze ho využít k mnoha všestranným účelům, ať už je to reklama nebo návod a nebo třeba zaznamenání vašich vzpomínek ze svatby. Jako nástroj komunikace je video budoucnost - s nástupem rychlého, levného a neomezeného internetu v mobilních zařízení se video již dnes stává hlavním médiem na mnoha platformách, přičemž adopce v budoucnu bude ještě větší. A tak vidíme nástup TikToku, jehož úspěch přebírají jak Instagram tak Facebook.',
  },
  {
    title: 'Jak probíhá točení videa - jaký je postup?',
    // nastaveni kamery -- vymysleni kde a jak to bude
    text: 'Proces točení videa se skládá z několika kroků. Prvním krokem je příprava, která zahrnuje vytvoření návrhu a scénáře, výběr scény, vymyšlení nastavení pozic kamery a světel, a zvolení formátu videa. Následuje samotné natáčení záběrů, kde je důležité získat dostatek ostrých a čistých záběrů pro střih. Finální fází je právě střih, který zahrnuje spojování záběrů do jednoho celku, přidávání hudby, titulků a efektů.',
  },
  // { title: 'Jak dlouho bude natáčení probíhat?', text: '' },
  // dela to scenarista a nebo videograf, vstupem je co je cil apod. scenar je zasadni pro odvypraveni pribehu, coz je naprosto klicove pro odvypraveni vasi message. Dobry tvurce vam
  // se scenarem poradi, bud vam ho pomuze vyrobit a nebo doporuci scenaristu, pripadne si scenaristu muzete vybrat na platforme sami.
  {
    title: 'Jak je to se scénářem?',
    text: 'Jak budete komunikovat vaši myšlenku publiku? Co se bude ve videu odehrávat, aby na diváka zapůsobilo a ten si jej zapamatoval? Skvělý scénář je základem úspěchu videa. Dobrý tvůrce vám s tvorbou scénáře pomůže, nebo doporučí svého scénáristu. A nebo si najděte scénaristu na naší platformě.',
  },
  {
    title: 'Proč se točí každý záběr několikrát?',
    text: `Točení každého záběru několikrát má zásadní dopad na kvalitu výsledného videa. Při točení několika záběrů si může režisér vybrat ty nejlepší záběry, což zlepšuje celkový dojem a kvalitu videa. Kromě toho může režisér při točení několika záběrů znovu zkontrolovat a nebo upravit postavení kamery, herců a poladit další detaily. To vše nejenže zlepší kvalitu videa, ale také ušetří čas a peníze při následné postprodukci.
    `,
  },
  // <br />
  // <br />
  //   Tvorba videa může být nákladná, protože zabere mnohem více času než jiné druhy mediální produkce. Točení každého záběru několikrát může mít vliv na cenu, protože to bude vyžadovat více času na natáčení, stříhání a postprodukci. Je však důležité si uvědomit, že to může vyplatit, protože výsledné video bude mnohem kvalitnější a přesnější.
  // video neni levna zalezitost, kvuli komplexnosti / mnozstvi praci, ale navratnost by mela byt radove lepsi nez u jinych formatu komunikace. ceny se pohybuji v ruznych skalach
  // dle zkusenosti a kvality videotvurce. Obdobne jako filmy, kde neplati cim drazsi tim lepsi, tak je to stejne u mensi videotvurby. mejte vsak na pameti, ze kvalita neco stoji,
  // tvurce ale overujte dle jeho referenci (a v budoucnu hodnoceni na nasi platforme)
  {
    title: 'Kolik stojí video?',
    text: `Tvorba videa je komplexní věc zahrnující přípravu, samotné natáčení a postprodukci a tak cena za video není nízká. Na druhou stranu, video odvede lepší práci než obrázek nebo text a tak může být návratnost investice řádově vyšší.
  <br />
  <br />
    Cena za tvorbu videa se může hodně lišit dle zkušeností a schopností videotvůrce. Pokud chcete dostat kvalitní video, bude to stát lidský čas a ten stojí peníze. Pokud budete tlačit na cenu, počítejte s tím, že to může být na úkor kvality videa, protože se někde bude šetřit - některé fáze se přeskočí nebo ošidí. Zároveň však nelze říci, že dražší je vždy lepší, tak jako to platí o klasických filmech.
  `,
  },
  // kazdy tvurce ma svuj rukopis / styl. pdole naseho katalogu si najdete tvurce, ktery vam svou tvorbou / referencemi sedi nejvice. Krom toho muzete zohlednit i ekonomicke a zkusenostni aspekty.
  // nasledne tvurce zkontaktuje skrze nas portal, ktery vam pomuze s uvodnim zadanim. (propojeni je zdarma pro obe strany) dale komunikace probiha mezi vami po mailu / telefonu\
  // jak si nastavite konkretni spolupraci uz je na vas a specifikach vaseho projektu.
  {
    title: 'Jak najít vhodného videotvůrce a jak probíhá spolupráce?',
    text: `Každý vidotvůrce má svůj rukopis / svůj styl tvorby, jako je to v případě hudební, fotografické nebo malířské tvorby. Na naší platformě si tak najděte dle referencí tvůrce, který vám bude svou tvorbou sedět nejvíce. Krom toho byste měli zohlednit jeho/její zkušenosti, také co vše je pro vás schopen zařídit, a ekonomické aspekty spolupráce.
  <br />
  <br />
  Následně tvůrce kontaktuje přes formulář na stránce - pomůže vám s vyplněním dostatečných podkladů pro zadání poptávky a zároveň uvidíte historii oslovení a nestane se tak, že někoho oslovíte dvakrát. Další komunikace již probíhá přímo mezi vámi emailem a nebo telefonicky a portál do ní nijak nezasahuje. To, jak si domluvíte spolupráci, už je pouze a jen na vás a specifikách vašeho projektu. 
  `,
  },
  {
    title: 'Proč poptat video tvůrce přes videotvurci.cz?',
    // vse na jednom miste... pokud hledate na googlu, nahore bude ten kdo ma nejlepsi seo a ne ten, kdo je nejlepsi. my davame sanci vsem  stejnou, bez ohlednu na to, jak maji optimalizovany web
    // nebo kolik maji penez na ppc reklamu
    text: `Věříme, že každý videotvůrce, ať už je známý nebo ne, by měl mít šanci vás zaujmout. Naše platforma dává šanci ukázat všem videotvůrcům, co v nich je, bez ohledu na to, jak mají dobrou SEO optimalizaci svého webu nebo kolik mají peněz na PPC reklamu do Googlu. Je mnoho videotvůrců, co umí tvořit dobrá videa, ale zároveň se neumí zviditelnit. A to chceme změnit. 
    <br />
    <br />
    Na našem portále naleznete na jednom místě přehledně velké množství videotvůrců a jejich reference, které můžete pohodlně filtrovat, prohlížet a porovnávat a tak najít toho pravého pro váš projekt.`,
    // text: 'Poptání video tvůrce přes videotvurci.cz může být užitečné, protože to umožňuje rychlý a efektivní způsob vyhledávání a porovnávání různých tvůrců na webu. Platforma může nabídnout širokou škálu možností, od profesionálních tvůrců videí s víceletou zkušeností až po nové, nadějné tvůrce, kteří hledají první příležitosti. Platforma může také poskytnout uživatelům informace o cenách, portfoliích a referencech každého tvůrce videa.',
  },
  {
    title: 'Je platforma Videotvůrci zdarma?',
    text: 'Ano! V současné době ani zájemce o video ani videotvůrce nic neplatí a celá služba je zdarma. V budoucnu plánujeme přidat premiové funkcionality, všechny dosavadní funkce ale budou vždy zdarma.',
  },
]

const FaqPage = () => {
  const [expanded, setExpanded] = useState(null)

  return (
    <Page bg="cloudLight">
      <SEO title="Časté otázky" />

      <PageContent maxWidth="600px">
        <Gap gap="32px" />
        <Heading type="display">Časté otázky</Heading>
        <Gap gap="32px" />

        <Accordion
          expandedSection={expanded}
          onExpand={(...all) => {
            console.log('all', all)
          }}
        >
          {faqs.map((faq, index) => (
            <AccordionSection
              header={(
                <Stack spacing="small">
                  <Text type="primary" size="large" weight="bold">
                    {faq.title}
                  </Text>
                </Stack>
              )}
              id={index}
              key={index}
              actions={(
                <Button
                  type="secondary"
                  onClick={() => {
                    // setExpanded({ ...expanded, [index]: !expanded[index] })
                    setExpanded(index)
                  }}
                >
                  Přečíst
                </Button>
              )}
            >
              <Text type="primary" as="div">
                <div dangerouslySetInnerHTML={{ __html: faq.text }} />
              </Text>
            </AccordionSection>
          ))}
        </Accordion>

        <Gap gap="32px" />
        <BetterText textAlign="center" width="100%">
          Nenašli jste vaší otázku?{' '}
          <BetterLink href="https://forms.gle/WnyDvAuJHTsUJuHe6" external>
            Napište nám
          </BetterLink>
          , zodpovíme vám ji.
        </BetterText>
      </PageContent>
      <Gap gap="64px" />
    </Page>
  )
}
export default FaqPage
